// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinkButton_wrapper__3Egx1","default":"LinkButton_default__3QrAD","attention":"LinkButton_attention__3TusQ"};